import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Optional, TemplateRef } from "@angular/core";
import { NzConfigService, WithConfig } from "ng-zorro-antd/core/config";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean, InputNumber } from "ng-zorro-antd/core/util";
import { NzSpinComponent } from "ng-zorro-antd/spin";
import { localize } from "@webapp/localization/utils/localization.utils";
import { UiLoadingIndicatorDirection, UiLoadingIndicatorSize, UiLoadingIndicatorTextPosition } from "@webapp/ui/loading-indicator/loading-indicator.models";

@Component({
  selector: "ui-loading-indicator",
  exportAs: "uiLoadingIndicator",
  templateUrl: "loading-indicator.component.html",
  styleUrls: ["loading-indicator.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[attr.aria-label]": "nzTip || localizeAriaLabel('loading')",
    "[attr.aria-live]": "'polite'",
    "[attr.aria-atomic]": "true",
  },
})
export class UiLoadingIndicatorComponent extends NzSpinComponent {
  @Input("uiIndicator") @WithConfig() public nzIndicator: TemplateRef<NzSafeAny> | null = null;
  @Input("uiSize") public size: UiLoadingIndicatorSize = "small";
  @Input("uiText") public nzTip: string | null = null;
  @Input("uiDelay") @InputNumber() public nzDelay = 1000;
  @Input("uiSimple") @InputBoolean() public nzSimple = false;
  @Input("uiSpinning") @InputBoolean() public nzSpinning: boolean;
  @Input("uiDirection") public uiDirection: UiLoadingIndicatorDirection = "circular";
  @Input("uiTextPosition") public uiTextPosition: UiLoadingIndicatorTextPosition = "right";

  constructor(nzConfigService: NzConfigService, cdr: ChangeDetectorRef, @Optional() directionality?: Directionality) {
    super(nzConfigService, cdr, directionality);
  }

  public localizeAriaLabel(key: string): string {
    return localize(key);
  }
}
